module.exports = __webpack_public_path__ + "static/media/ed_bg.a0c36d8b.png";